/*
 * Get-staff-data.ts
 * Description: Includes the declaration
 * of the function for getting data of a staff members
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Getting staff member data
 *
 * @return {Object} Promise - staff member data
 * @param {String} slug - id of the restaurant
 * @param {Number} userId - id of the user
 */
export function getStaffData(slug: string, userId: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/users/' + userId,
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            resolve(response.data);
        }).catch(() => {
            reject();
        });
    });
}
